(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hyde-header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-section-type="hyde-header"]');
    if (!header) return;

    const hamburger = header.querySelector('[data-hamburger]');
    const drawer = document.getElementById('hyde-header-drawer');
    if (!drawer) return;

    const closeBtns = drawer.querySelectorAll('[data-drawer-close]');
    const drawerLinks = drawer.querySelectorAll('a');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const firstLink = drawer.querySelector('a');
      if (firstLink) firstLink.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    hamburger.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    drawerLinks.forEach(function (link) {
      link.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    const mainContent = document.getElementById('MainContent');

    function updateHeaderHeight() {
      const h = header.offsetHeight;
      document.body.style.setProperty('--header-height', h + 'px');
      if (mainContent) {
        mainContent.style.paddingTop = h + 'px';
      }
    }
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
